import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDYNA142SVTL6aNZudO_BL6Yk31DANbkSk",
  authDomain: "noteworthy-collections.firebaseapp.com",
  projectId: "noteworthy-collections",
  storageBucket: "noteworthy-collections.appspot.com",
  messagingSenderId: "286076840352",
  appId: "1:286076840352:web:0c9db94c27485482851cc5",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
